



<section class="home-about mt-lg-5 about-section">
    <div class="container-fluid">
        <div class="row center-align p-5">
            <div class="col-md-6">
                <div class="about">
                    <h2 class="text-dark">
                        {{"compony about" | translate}}
                    </h2>
                    <p class="text-dark">
                        {{"compony about2" | translate}}
                    </p>
                </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center text-center">
                <img src="./../../../assets/images/about.png" alt="about" width="350" />
            </div>
        </div>

        
    </div>
</section>



<section class="seo-service about-section mt-3">
    <div class="container-fluid">
        <div class="row center-align p-5 flex-row-reverse">
            <div class="col-md-6">
                <div class="service">
                    <h2 class="text-dark">
                        {{"compony about3" | translate}}
                    </h2>
                    <p class="text-dark">
                        {{"compony about4" | translate}}
                    </p>
                </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center text-center">
                <img src="./../../../assets/images/ecommerce.png" alt="seo" width="500" />
            </div>
        </div>
    </div>
</section>